module.exports = __webpack_public_path__ + "img/thumbnail-5@2x.6b19ba97.jpg";